module.exports = __webpack_public_path__ + "img/ind_report_logo.b43cebef.png";